
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[festivalId]",
      function () {
        return require("private-next-pages/[festivalId]/index.js");
      }
    ]);
  